/** A 1 Hz reactive clock, so countdown timers re-render every second. */
import A from 'aberdeen';

export const $now = A.proxy(Date.now());
setInterval(() => {
  $now.value = Date.now();
}, 1000);
